import { render, staticRenderFns } from "./menu-item.component.vue?vue&type=template&id=d64c87fa&scoped=true&"
import script from "./menu-item.component.vue?vue&type=script&lang=ts&"
export * from "./menu-item.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu-item.component.vue?vue&type=style&index=0&id=d64c87fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64c87fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemIcon})
